import React, { useEffect, Fragment, useState } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import Home from 'plugins/tfs/pages/home';
import StoreSelection from 'plugins/tfs/pages/storeSelection';
import Login from 'plugins/tfs/pages/login';
import StaffLogin from 'plugins/tfs/pages/login/staffLogin';
import StaffSelection from 'plugins/tfs/pages/staffSelection';
import NewUser from 'plugins/tfs/pages/auth';
import ProductSearch from 'plugins/tfs/pages/product/search';
import ProductList from 'plugins/tfs/pages/product/list';
import ProductDetail from 'plugins/tfs/pages/product/detail';
import Basket from 'plugins/tfs/pages/basket/basket';
import Checkout from 'plugins/tfs/pages/checkout/checkout';
import ThankYou from 'plugins/tfs/pages/checkout/thankyou';
import UserSearch from 'plugins/tfs/pages/customer/customerList';
import CustomerInfo from 'plugins/tfs/pages/customer/customerDetail';
import OrderSearch from 'plugins/tfs/pages/orders/search';
import OrderRefundDetail from 'plugins/tfs/pages/orders/refund/orderRefundDetail';
import OrderRefundComplete from 'plugins/tfs/pages/orders/refund/orderRefundComplete';
import OrderSearchCancellation from 'plugins/tfs/pages/orders/searchCancellation';
import OrderCancellationDetail from 'plugins/tfs/pages/orders/cancellation/orderCancellationDetail';
import OrderCancellationComplete from 'plugins/tfs/pages/orders/cancellation/orderCancellationComplete';
import OrderAcceptComplete from 'plugins/tfs/pages/orders/acceptComplete';
import OrderDeliveryComplete from 'plugins/tfs/pages/orders/deliveryComplete';
import PackageOrderList from 'plugins/tfs/pages/oms/PackageOrderList/main';
import PackageOrderDetail from 'plugins/tfs/pages/oms/PackageOrderDetail/main';
import TransferOrderList from 'plugins/tfs/pages/oms/TransferOrderList/main';
import TransferOrderDetail from 'plugins/tfs/pages/oms/TransferOrderDetail/main';
import Guest from 'plugins/tfs/pages/customer/guest';

import WidgetPages from 'components/partials/WidgetPages';
import ImageModal from 'components/partials/ImageModal';
import { hasPermission, isExecutive } from 'utils/permission';
import { isAuthorized, handleStarterPages } from 'utils';

import $S from 'theme/settings';

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/permissions`);

const Router = (props) => {
  const [redirectHome, setRedirectHome] = useState(false);
  const [starterPagesControl, setStarterPagesControl] = useState(false);

  useEffect(() => {
    if ($R.REDIRECTS.length > 0) {
      const redirect = findRedirect();
      redirect && props.history.push(redirect.to);
    }
  }, []);

  useEffect(() => {
    let starterPagesControl = handleStarterPages();
    if (starterPagesControl) {
      setStarterPagesControl(true);
    } else {
      let authorized = isAuthorized();
      !authorized ? setRedirectHome(true) : setRedirectHome(false);
    }
  }, []);

  const findRedirect = () => {
    const { store, location = {} } = props;
    const {
      permissions: { permissions = [] },
    } = store.getState();

    const matchedCurrentRoutes = $R.REDIRECTS.filter(
      ({ from, active }) => active && from === location.pathname
    );

    if (!$S.hasPermissionForPages) {
      return matchedCurrentRoutes[0];
    }

    const allowedRoutes = matchedCurrentRoutes.filter(({ to }) => {
      return (
        isExecutive(permissions, $P.IS_ADMIN) ||
        isExecutive(permissions, $P.IS_SUPER_USER) ||
        hasPermission(permissions, to)
      );
    });

    return allowedRoutes[0];
  };

  const isAccessible = (Screen, routeConfig, routeProps) => {
    const { id: staffId } = props.store.getState().staffs.currentStaff;
    const { id: storeId } = props.store.getState().stores.currentStore;
    const { active, requirement } = routeConfig;
    const isStoreSelected = storeId && requirement === 'store-selection';
    const isLoggedIn = staffId && requirement === 'login';
    const isStaffLoggedIn = storeId && requirement === 'staff-login';

    if ((isStoreSelected || isLoggedIn || isStaffLoggedIn) && active) {
      return <Screen {...routeProps} />;
    } else if (routeProps.location.pathname === '/') {
      return <Redirect to='/store-selection' />;
    } else {
      return <Screen {...routeProps} />;
    }
  };

  if (redirectHome && window.location.pathname !== '/store-selection') {
    return <Redirect push to={$R.STORE_SELECTION.path} />;
  } else if (
    starterPagesControl &&
    window.location.pathname !== '/store-selection'
  ) {
    return <Redirect push to={$R.STORE_SELECTION.path} />;
  }

  return (
    <Fragment>
      <Switch>
        <Route path={$R.STORE_SELECTION.path} component={StoreSelection} />
        <Route
          exact
          path={$R.HOME.path}
          render={(routeProps) => isAccessible(Home, $R.HOME, routeProps)}
        />
        <Route exact path={$R.LOGIN.path} component={Login} />
        <Route
          exact
          path={$R.STAFF_LOGIN.path}
          render={(routeProps) =>
            isAccessible(StaffLogin, $R.STAFF_LOGIN, routeProps)
          }
        />
        <Route
          exact
          path={$R.STAFF_SELECTION.path}
          component={StaffSelection}
        />
        <Route exact path={$R.MAIN_HOME.path} component={Home} />
        <Route exact path={$R.NEW_USER.path} component={NewUser} />
        <Route exact path={$R.PRODUCT_SEARCH.path} component={ProductSearch} />
        <Route path={$R.PRODUCT_LIST.path + '/:url?'} component={ProductList} />
        <Route
          path={$R.PRODUCT_DETAIL.path + '/:productPk'}
          component={ProductDetail}
        />
        <Route exact path={$R.BASKET.path} component={Basket} />
        <Route exact path={$R.CHECKOUT.path} component={Checkout} />
        <Route exact path={$R.CHECKOUT_THANK_YOU.path} component={ThankYou} />
        <Route exact path={$R.CUSTOMER_LIST.path} component={UserSearch} />
        <Route
          exact
          path={$R.CUSTOMER_DETAIL.path + '/:customerPk'}
          component={CustomerInfo}
        />
        <Route
          exact
          path={$R.ORDER_REFUND_SEARCH.path}
          render={(routeProps) => {
            routeProps.main = 'refund';
            return isAccessible(
              OrderSearch,
              $R.ORDER_REFUND_SEARCH,
              routeProps
            );
          }}
        />
        <Route
          exact
          path={$R.ORDER_REFUND_DETAIL.path}
          component={OrderRefundDetail}
        />
        <Route
          exact
          path={$R.ORDER_REFUND_COMPLETE.path}
          component={OrderRefundComplete}
        />

        <Route
          exact
          path={$R.ORDER_CANCELLATION_SEARCH.path}
          render={(routeProps) => {
            routeProps.main = 'cancel';
            return isAccessible(
              OrderSearchCancellation,
              $R.ORDER_CANCELLATION_SEARCH,
              routeProps
            );
          }}
        />

        <Route
          exact
          path={$R.ORDER_CANCELLATION_SEARCH.path}
          render={(routeProps) => {
            routeProps.main = 'refund';
            return isAccessible(
              OrderSearch,
              $R.ORDER_CANCELLATION_SEARCH,
              routeProps
            );
          }}
        />
        <Route
          exact
          path={$R.ORDER_CANCELLATION_DETAIL.path}
          component={OrderCancellationDetail}
        />
        <Route
          exact
          path={$R.ORDER_CANCELLATION_COMPLETE.path}
          component={OrderCancellationComplete}
        />
        <Route
          exact
          path={$R.ORDER_ACCEPT_SEARCH.path}
          render={(routeProps) => {
            routeProps.main = 'accept';
            return isAccessible(
              OrderSearch,
              $R.ORDER_ACCEPT_SEARCH,
              routeProps
            );
          }}
        />
        <Route
          exact
          path={$R.ORDER_ACCEPT_COMPLETE.path}
          component={OrderAcceptComplete}
        />
        <Route
          path={$R.ORDER_DELIVERY_SEARCH.path}
          render={(routeProps) => {
            routeProps.main = 'delivery';
            return isAccessible(
              OrderSearch,
              $R.ORDER_DELIVERY_SEARCH,
              routeProps
            );
          }}
        />
        <Route
          exact
          path={$R.ORDER_DELIVERY_COMPLETE.path}
          component={OrderDeliveryComplete}
        />
        <Route
          key={$R.PACKAGE_ORDER_LIST_COLLECTING.path}
          path={$R.PACKAGE_ORDER_LIST_COLLECTING.path}
          render={(routeProps) =>
            isAccessible(
              PackageOrderList,
              $R.PACKAGE_ORDER_LIST_COLLECTING,
              routeProps
            )
          }
        />
        <Route
          key={$R.PACKAGE_ORDER_LIST_PACKAGING.path}
          path={$R.PACKAGE_ORDER_LIST_PACKAGING.path}
          render={(routeProps) =>
            isAccessible(
              PackageOrderList,
              $R.PACKAGE_ORDER_LIST_PACKAGING,
              routeProps
            )
          }
        />
        <Route
          key={$R.PACKAGE_ORDER_LIST_DISTRIBUTION.path}
          path={$R.PACKAGE_ORDER_LIST_DISTRIBUTION.path}
          render={(routeProps) =>
            isAccessible(
              PackageOrderList,
              $R.PACKAGE_ORDER_LIST_DISTRIBUTION,
              routeProps
            )
          }
        />
        <Route
          exact
          path={$R.PACKAGE_ORDER_LIST.path}
          component={PackageOrderList}
        />
        <Route
          exact
          path={$R.PACKAGE_ORDER_DETAIL.path + '/:packageOrderId'}
          component={PackageOrderDetail}
        />
        <Route
          exact
          path={$R.TRANSFER_ORDER_LIST.path}
          component={TransferOrderList}
        />
        <Route
          exact
          path={$R.TRANSFER_ORDER_DETAIL.path + '/:transferOrderId'}
          component={TransferOrderDetail}
        />
        <Route exact path={$R.GUEST.path} component={Guest} />
        <Route
          path={`${$R.WIDGET_PAGES.path}/:slug`}
          render={(routeProps) =>
            isAccessible(WidgetPages, $R.WIDGET_PAGES, routeProps)
          }
        />
      </Switch>
      <Route component={ImageModal} />
    </Fragment>
  );
};

export { Router };

export default withRouter(Router);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/router/index.js